import React, { forwardRef } from "react";
import clsx from "clsx";

const Textarea = forwardRef(({
  label,
  error,
  helperText,
  fullWidth = true,
  className = "",
  textareaClassName = "",
  disabled = false,
  required = false,
  id,
  rows = 4,
  resize = "vertical",
  ...props
}, ref) => {
  const textareaId = id || `textarea-${Math.random().toString(36).substr(2, 9)}`;

  const resizeClasses = {
    none: "resize-none",
    vertical: "resize-y",
    horizontal: "resize-x",
    both: "resize",
  };

  return (
    <div className={clsx(fullWidth ? "w-full" : "inline-block", className)}>
      {label && (
        <label
          htmlFor={textareaId}
          className="block text-sm font-medium text-dark-700 dark:text-dark-300 mb-1"
        >
          {label}
          {required && <span className="text-danger-500 ml-1">*</span>}
        </label>
      )}
      <textarea
        ref={ref}
        id={textareaId}
        disabled={disabled}
        rows={rows}
        className={clsx(
          "w-full px-3 py-2 text-sm border rounded-lg",
          "bg-white dark:bg-dark-800",
          "text-dark-900 dark:text-dark-100",
          "placeholder-dark-400 dark:placeholder-dark-500",
          "transition-colors duration-200",
          "disabled:bg-dark-100 disabled:dark:bg-dark-700 disabled:cursor-not-allowed",
          "focus:outline-none focus:ring-2 focus:ring-offset-0",
          error
            ? "border-danger-500 focus:border-danger-500 focus:ring-danger-500/20"
            : "border-dark-300 dark:border-dark-600 focus:border-primary-500 focus:ring-primary-500/20",
          resizeClasses[resize],
          textareaClassName
        )}
        {...props}
      />
      {(error || helperText) && (
        <p
          className={clsx(
            "mt-1 text-xs",
            error ? "text-danger-500" : "text-dark-500 dark:text-dark-400"
          )}
        >
          {error || helperText}
        </p>
      )}
    </div>
  );
});

Textarea.displayName = "Textarea";

export default Textarea;
